export const actionKey = '@@HISTORY';
export const reduxKey = '@@HISTORY';
